(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mg-pumpkin-product"] && !Shopify.designMode) return;
  try {
    
  function initializePumpkin(root = document) {
    root.querySelectorAll('[data-pumpkin-gallery]:not([data-enhanced])').forEach(gallery => {
      const images = [...gallery.querySelectorAll('[data-gallery-image]')];
      const buttons = [...gallery.querySelectorAll('[data-image-index]')];
      if (images.length < 2) return;
      gallery.dataset.enhanced = 'true';
      gallery.querySelector('.mg-pumpkin__thumbnails').hidden = false;
      const show = index => {
        images.forEach((image, i) => { image.hidden = i !== index; });
        buttons.forEach((button, i) => { button.setAttribute('aria-pressed', String(i === index)); });
      };
      buttons.forEach((button, index) => button.addEventListener('click', () => { current = index; show(index); }));

      // Phone: every image sits in a swipeable track with arrows and an "n / total" counter.
      const track = gallery.querySelector('[data-pumpkin-track]');
      const nav = gallery.querySelector('[data-pumpkin-mobile-nav]');
      const counter = gallery.querySelector('[data-pumpkin-counter]');
      const mobile = window.matchMedia('(max-width: 749px)');
      let current = 0;
      const indexFromScroll = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      const setCounter = (i) => { current = i; if (counter) counter.textContent = `${i + 1} / ${images.length}`; };
      const goTo = (i) => {
        const next = (i + images.length) % images.length;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({ left: next * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
        setCounter(next);
      };
      gallery.querySelector('[data-pumpkin-prev]')?.addEventListener('click', () => goTo(indexFromScroll() - 1));
      gallery.querySelector('[data-pumpkin-next]')?.addEventListener('click', () => goTo(indexFromScroll() + 1));
      track.addEventListener('scroll', () => {
        if (!mobile.matches) return;
        cancelAnimationFrame(track._mgFrame);
        track._mgFrame = requestAnimationFrame(() => setCounter(indexFromScroll()));
      }, { passive: true });
      const applyLayout = () => {
        if (mobile.matches) {
          gallery.dataset.mobile = '';
          images.forEach((image) => { image.hidden = false; });
          if (nav) nav.hidden = false;
          track.scrollLeft = current * track.clientWidth;
          setCounter(current);
        } else {
          delete gallery.dataset.mobile;
          if (nav) nav.hidden = true;
          show(current);
        }
      };
      show(0);
      mobile.addEventListener('change', applyLayout);
      applyLayout();
    });
    root.querySelectorAll('[data-pumpkin-stepper]:not([data-enhanced])').forEach(stepper => {
      const input = stepper.querySelector('input');
      const buttons = [...stepper.querySelectorAll('button')];
      stepper.dataset.enhanced = 'true';
      const update = () => { buttons[0].disabled = Number(input.value) <= 1; };
      buttons.forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => {
          input.value = String(Math.max(1, Math.floor(Number(input.value) || 1) + Number(button.dataset.quantityChange)));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          update();
        });
      });
      input.addEventListener('change', () => {
        input.value = String(Math.max(1, Math.floor(Number(input.value) || 1)));
        update();
      });
      update();
    });
  }
  initializePumpkin();
  document.addEventListener('shopify:section:load', event => initializePumpkin(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mg-shop"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-catalog-sort]')) return;
    const url = new URL(location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    location.assign(url.toString());
  });

  } catch(e) { console.error(e); }
})();
})();
